import React, { useState, useEffect } from "react";
import QrReader from "react-qr-reader";
import { getSignature } from "../../services/api/certificate-service";
import Header from "../../components/Header/Header";

//@ts-ignore
import styled from "styled-components";

import CustomDialog from "./components/dialog";
import CertificateDemographic from "./components/certificate-demographics";
import { LoaderWithContent } from "./components/loader";
import { useLocation } from "react-router";

interface IScanData {
  epiNumber?: string;
  signature: string;
}

export default function ValidateCertificate() {
  const [scannedData, setScannedData] = useState<IScanData>({} as IScanData);

  const signature = new URLSearchParams(useLocation().search).get("sg");

  const handleDialogClose = () => {
    setScannedData({} as IScanData);
  };

  useEffect(() => {
    if (!signature) return;
    validateDigitalSignature(signature);
  }, []);

  const validateDigitalSignature = async (data: any) => {
    if (!data) return;

    CustomDialog(
      "info",
      "",
      <LoaderWithContent content="Validating Certificate..." />,
      false,
      () => {},
      "20rem"
    );

    setScannedData({ signature: data });

    const response = await getSignature(data);

    if (response.status)
      return CustomDialog(
        "error",
        "Error",
        response.data.message,
        false,
        handleDialogClose,
        "43rem",
        true
      );

    if (response.signature === data) {
      CustomDialog(
        "success",
        "Valid Certificate",
        <CertificateDemographic certificate={response} />,
        false,
        handleDialogClose,
        "43rem",
        true
      );
      return;
    }
    CustomDialog(
      "error",
      "error",
      "mismatch",
      false,
      handleDialogClose,
      "43rem",
      true
    );
  };

  const handleError = (error: any) => {
    console.log(error);
  };

  const handleScan = (data: any) => {
    if (!data) return;
    if (scannedData.signature) return;

    try {
      const jsonData = JSON.parse(data);
      validateDigitalSignature(jsonData.signature);
    } catch (error) {
      const sg = String(data).split("?sg=")[1];
      validateDigitalSignature(sg);
    }
  };
  return (
    <>
      <Header />
      <Wrapper>
        <Header />
        <InfoText>Scan Certificate QRCode</InfoText>
        <QrReader delay={300} onError={handleError} onScan={handleScan} />
      </Wrapper>
    </>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20rem;
  justify-content: center;
  align-items: center;

  & > section {
    width: 30%;
    @media (max-width: 960px) {
      width: 90%;
    }
  }
`;
const InfoText = styled.h2`
  margin-top: 10rem;
  @media (max-width: 960px) {
    margin-top: 0px;
    font-size: medium;
  }
`;
